export default __webpack_public_path__ + "static/media/permit.48d5a5cf.svg";